import { ELEMENT_TYPE, Element } from '@vindr/services/apis/element.api';
import { StructuredReportElement } from '../types';
import { isBlockTag } from '@vindr/utils/helpers/detect';

export interface BaseElementProps extends Element {
  value?: string;
  highlight?: boolean;
  level?: number;
  parent?: StructuredReportElement;
  is_hidden?: boolean;
}

export abstract class BaseElement {
  public id: BaseElementProps['id'];
  public name: BaseElementProps['name'];
  public value: BaseElementProps['value'];
  public tooltip: BaseElementProps['tooltip'];
  public label: BaseElementProps['label'];
  public is_hidden: BaseElementProps['is_hidden'];
  public highlight: boolean;
  public type: ELEMENT_TYPE;
  public parent: StructuredReportElement;
  public level: number;
  public linked_element_ids: string[];

  constructor(props: BaseElementProps) {
    const { id, name, value, tooltip, type, highlight } = props || {};
    this.id = id;
    this.name = name;
    this.value = value || '';
    this.tooltip = tooltip || '';
    this.type = type;
    this.highlight = highlight;
    this.parent = props?.parent || null;
    this.level = props?.level;
    this.linked_element_ids = props?.linked_element_ids;
    this.is_hidden = props?.is_hidden;
    props.elements;

    // if (props.elements && Array.isArray(props.elements)) {
    //   this.elements = props.elements.map((el: any) => ElementFactory.createElement(el));
    // }
  }

  setValue(value: any): void {
    this.value = value;
  }

  setIsHidden(isHidden: boolean): void {
    this.is_hidden = isHidden;
  }

  // public abstract render(): string;
  render() {
    throw new Error('Render method not implemented.');
  }
  // public abstract setValue(val: any): void;
  public setHighlight(val: boolean) {
    this.highlight = val;
  }

  public withHighlight = (content: string) => {
    const wrapperTag = isBlockTag(content) ? 'div' : 'span';
    return `<${wrapperTag} data-name="highlight-wrapper" style="${
      this.highlight ? 'background-color: yellow;' : ''
    }">${content}</${wrapperTag}>`;
  };
}

export default BaseElement;
